export default {
  ROOMING_LIST: {
    label: "Rooming List Importation",
    name: "roomingList",
  },
};
